@import "../../../styles/variables.scss";

.cta-banner {
  &__container {
    background-color: $svs-super-light-grey;
    border: 1px solid #cbcbcb;
    margin-bottom: 20px;
    overflow: hidden;

    @media (min-width: $uiaas-tablet) {
      margin-right: var(--margin-right-cta-banner, 20px);
    }

    &--fluid {
      margin-bottom: 20px;
      margin-right: 0;
    }
  }

  &__link {
    text-decoration: none;
    color: #333333;

    &:focus-visible {
      overflow: hidden;
    }
  }

  &__content {
    box-sizing: content-box;
    display: flex;
    flex-wrap: wrap;
    align-items: start;
    padding: 20px;

    @media (min-width: $uiaas-tablet) {
      align-items: center;
      flex-wrap: nowrap;
    }
  }

  &__label-wrapper {
    flex-grow: 1;
    align-self: center;
  }

  &__label {
    overflow: hidden;
    color: var(--srp-greyscale-anthracite-grey-333333, #333);
    text-overflow: ellipsis;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    white-space: break-spaces;

    &--boldless b {
      font-weight: inherit;
    }
  }

  &__cta {
    padding-top: 16px;
    width: 100%;

    qds-button {
      width: 100%;
    }

    @media (min-width: $uiaas-tablet) {
      width: auto;
      padding-left: 16px;
      padding-top: 0;
      qds-button {
        width: auto;
      }
    }
  }

  &__info-icon {
    display: none;
    align-items: center;
    padding-right: 12px;

    @media (min-width: $uiaas-tablet) {
      display: flex;
    }

    svg {
      width: 32px;
      height: 32px;
    }
  }

  &__cta-icon {
    margin-left: 20px;
  }

  &__heading {
    font-size: 22px;
    font-weight: 700;
    line-height: 30px;
    margin: 0 0 4px;
  }
}
